import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a689b842"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer flex column gap-20" }
const _hoisted_2 = { class: "inputs flex column gap-20 flex-1" }
const _hoisted_3 = { class: "title font-size-14 text-primary flex align-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "拖入檔案來上傳")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "image-container"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "operator flex align-center justify-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "拖入檔案來上傳")
], -1))
const _hoisted_9 = { class: "ops flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _ctx.title,
    modelValue: _ctx.drawer,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawer) = $event)),
    direction: "rtl",
    wrapperClosable: false,
    "close-on-click-modal": false,
    "before-close": _ctx.handleClose,
    "append-to-body": _ctx.appendToBody
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datas, (data, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input flex column gap-10",
              key: data.key
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(data.name), 1),
              (data.type === _ctx.ColumnType.Text)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: data.value,
                    "onUpdate:modelValue": ($event: any) => ((data.value) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : (data.type === _ctx.ColumnType.Select)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 1,
                      modelValue: data.value,
                      "onUpdate:modelValue": ($event: any) => ((data.value) = $event)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.options, (opt) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: opt.value,
                            value: opt.value,
                            label: opt.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  : (data.type === _ctx.ColumnType.Password)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 2,
                        modelValue: data.value,
                        "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                        type: "password"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : (data.type === _ctx.ColumnType.Image)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createVNode(_component_el_upload, {
                            drag: "",
                            action: "https://bat.bearathome.com.tw/api/image/upload",
                            "list-type": "picture",
                            headers: _ctx.uploadHeader,
                            onSuccess: _ctx.genHandleUploadSuccess(idx),
                            onExceed: _ctx.handleExceed,
                            limit: 1,
                            accept: "image/png, image/jpeg, image/jpg",
                            ref_for: true,
                            ref: "uploader"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_upload_filled)
                                ]),
                                _: 1
                              }),
                              _hoisted_4
                            ]),
                            _: 2
                          }, 1032, ["headers", "onSuccess", "onExceed"]),
                          (data.value !== '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("img", {
                                  src: `https://bat.bearathome.com.tw/api/image/${data.value}`
                                }, null, 8, _hoisted_6),
                                _createElementVNode("div", _hoisted_7, [
                                  _createVNode(_component_el_button, {
                                    type: "danger",
                                    size: "mini",
                                    icon: _ctx.Delete,
                                    onClick: ($event: any) => (data.value = '')
                                  }, null, 8, ["icon", "onClick"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (data.type === _ctx.ColumnType.Images)
                        ? (_openBlock(), _createBlock(_component_el_upload, {
                            key: 4,
                            drag: "",
                            action: "https://bat.bearathome.com.tw/api/image/upload",
                            "list-type": "picture",
                            headers: _ctx.uploadHeader,
                            onSuccess: _ctx.genHandleUploadMultiSuccess(idx),
                            onExceed: _ctx.handleExceed,
                            limit: 10,
                            multiple: "",
                            accept: "image/png, image/jpeg, image/jpg",
                            ref_for: true,
                            ref: "uploader"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_upload_filled)
                                ]),
                                _: 1
                              }),
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["headers", "onSuccess", "onExceed"]))
                        : (data.type === _ctx.ColumnType.MultiText)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (v, vidx) => {
                                return (_openBlock(), _createBlock(_component_el_input, {
                                  key: v,
                                  modelValue: data.value[vidx],
                                  "onUpdate:modelValue": ($event: any) => ((data.value[vidx]) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              }), 128)),
                              _createVNode(_component_el_button, {
                                type: "mini",
                                onClick: ($event: any) => ((data.value as string[]).push(' '))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("新增一個")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ], 64))
                          : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            class: "flex-1",
            onClick: _ctx.finish,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("儲存")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            class: "flex-1",
            onClick: _ctx.cancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close", "append-to-body"]))
}